
export type FilterByLevelParamParameter = typeof FilterByLevelParamParameter[keyof typeof FilterByLevelParamParameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilterByLevelParamParameter = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
